__turbopack_context__.v({
  "arrow": "ForumResultItem-module-scss-module__tMjT2W__arrow",
  "avatarContainer": "ForumResultItem-module-scss-module__tMjT2W__avatarContainer",
  "viewMore": "ForumResultItem-module-scss-module__tMjT2W__viewMore",
});
